import { useTranslation } from "react-i18next";

export default function BeveiligingPreventie() {
  const { t } = useTranslation("inbraakschade-reparatie");
  const items = t("beveiligingPreventie.items", { returnObjects: true }) as Array<{
    title: string;
    text: string;
  }>;

  const icons = [
    "ri-shield-check-line",
    "ri-lock-2-line",
    "ri-door-lock-line",
    "ri-lightbulb-line",
  ];

  return (
    <section className="bg-white py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <div className="max-w-[800px] mx-auto text-center mb-10 md:mb-14">
          <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight mb-5 md:mb-6">
            {t("beveiligingPreventie.h2")}
          </h2>
          <p className="font-geist text-base md:text-lg text-brand-text/80 leading-relaxed">
            {t("beveiligingPreventie.intro")}
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((item, i) => (
            <div
              key={i}
              className="bg-white border border-brand-border rounded-2xl p-6 md:p-8 text-center hover:border-brand-yellow transition-colors"
            >
              <div className="w-12 h-12 rounded-full bg-brand-yellow flex items-center justify-center mx-auto mb-5">
                <i className={`${icons[i]} text-brand-text text-xl w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="font-geist font-bold text-base text-brand-text mb-2">
                {item.title}
              </h3>
              <p className="font-geist text-sm text-brand-text/70 leading-relaxed">
                {item.text}
              </p>
            </div>
          ))}
        </div>
        <div className="text-center mt-10">
          <a
            href={t("beveiligingPreventie.ctaUrl")}
            className="inline-flex items-center gap-2 font-geist font-bold text-sm bg-brand-text text-white px-6 md:px-8 py-3.5 md:py-4 rounded-full hover:bg-brand-blue transition-colors whitespace-nowrap"
          >
            {t("beveiligingPreventie.cta")}
          </a>
        </div>
      </div>
    </section>
  );
}